import Container from "@/components/common/Container";
import Image from "next/image";
import Title from "./common/Title";

const MOBIFINIX_TECH_IMAGE_DATA = [
  {
    id: 1,
    alt: "react",
    height: 64,
    src: "/assets/case-study/dating-app/react-hover.webp",
    width: 72,
  },
  {
    id: 2,
    alt: "typescript",
    height: 64,
    src: "/assets/case-study/mobifinx/typescript.webp",
    width: 64,
  },
  {
    id: 3,
    alt: "tailwind",
    height: 38,
    src: "/assets/case-study/mobifinx/tailwind.webp",
    width: 64,
  },
  {
    id: 4,
    alt: "figma",
    height: 64,
    src: "/assets/case-study/dating-app/figma-hover.webp",
    width: 42,
  },
];

const Technology = () => (
  <Container className="py-20 xl:py-36">
    <Title
      textBlack
      className="md:pl-16 xl:pl-24 pb-6 md:pb-10 xl:pb-20 w-full md:w-4/5 xl:w-3/4"
      customClass="pb-6 xl:pb-10"
      Description="In developing our blockchain-powered digital asset trading platform, we have skillfully combined various technologies to provide users with a seamless and secure experience. Our front-end utilizes responsive web technologies like Next.js, ensuring a consistent user experience across different devices with a SEO friendly approach.
            <br/><br/>
            Through the strategic alignment of these technologies, we have developed a resilient and user-focused platform that empowers traders to navigate the dynamic world of digital asset trading with confidence and smooth tranisitions."
      SubTitle="Technology Stack"
    />
    <Container large>
      <div className="md:pl-16 xl:pl-24 flex items-center">
        {MOBIFINIX_TECH_IMAGE_DATA.map((value, index) => (
          <div
            key={value.id}
            className={`fs-0  ${
              MOBIFINIX_TECH_IMAGE_DATA.length === index + 1 ? "pr-0" : "pr-16"
            }`}
          >
            <Image
              key={value.alt}
              alt={value.alt}
              height={value.height}
              src={value.src}
              width={value.width}
            />
          </div>
        ))}
      </div>
    </Container>
  </Container>
);

export default Technology;
